var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		'component-popup',
		this.$store.getters.getIsMobile ? 'mobile' : ''
	],style:({
		marginTop: _vm.marginTop + 'px',
		marginLeft: _vm.marginLeft + 'px',
		height: _vm.height
	})},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"close",on:{"click":_vm.onCloseClick,"touchstart":_vm.onCloseClick}},[_c('div',[_vm._v("+")])]),_c('div',{staticClass:"content"},[_c('ul',_vm._l((_vm.content),function(line,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(line)+" ")])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }